import React from 'react';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import classes from 'components/common/Tables/Cells/ComplianceRangeCell/ComplianceRangeCell.module.scss';
import { CustomizedTooltip } from 'components/common/index';

export const ComplianceRangeCell = ({ noneCompliant, compliant, failedPercent, passedPercent }) => {
    return (
        <CustomizedTooltip
            tooltipPosition={TooltipPosition.Top}
            tooltipContent={
                <>
                    <span className={classes.failed}>Failed: {failedPercent}</span>,{' '}
                    <span className={classes.passed}>Passed: {passedPercent}</span>
                </>
            }
            triggerElement={
                <div className={classes.container}>
                    <div className={classes.red} style={{ width: noneCompliant }} />
                    <div className={classes.green} style={{ width: compliant }} />
                </div>
            }
        />
    );
};
